var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputRef",attrs:{"type":"text"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('enter')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }